import React from 'react';
import * as R from 'ramda';
import {getRowDataForColumnComponent} from 'js/common/griddle_column_helper';

const Creator = (viewUserUrl, campaignType) => props => {
    const {lead, campaign_type} = getRowDataForColumnComponent(props);
    const username = lead[campaign_type].social_username;
    const socialUrl = R.prop(campaign_type, {
        [campaignType.INSTAGRAM]: `https://www.instagram.com/${username}`,
        [campaignType.YOUTUBE]: `https://www.youtube.com/channel/${username}`,
        [campaignType.TWITTER]: `https://www.twitter.com/${username}`
    });

    const leadId = lead?.user_profile?.lead_id;

    return (
        <div>
            <div>
                <a href={socialUrl} title={socialUrl} target="_blank" rel="noopener noreferrer">
                    @{username}
                </a>
            </div>
            <div>
                {leadId ? (
                    <a
                        href={viewUserUrl.replace('__ID__', lead.user_profile.lead_id)}
                        title="Leads Page"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Leads Page
                    </a>
                ) : (
                    'CRM Lead Missing'
                )}
            </div>
        </div>
    );
};

export default Creator;



// WEBPACK FOOTER //
// ./admin_operations/shipping/components/creator.js